.container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.input {
  // Reset
  border: none;
  background: none;
  margin: 0;
  padding: 0;
  outline: none;

  // Sizing - fixed width per Figma spec (56px x 80px)
  width: 56px;
  height: 80px;
  flex-shrink: 0;

  // Visual
  background-color: transparent;
  border: 1px solid var(--color-grey-neutral);
  border-radius: map.get($radius, 'md');
  overflow: hidden;

  // Typography
  font-family: $font-family-base;
  font-size: 40px;
  font-weight: map.get($font-weights, 'regular');
  line-height: 1;
  text-align: center;
  color: var(--color-text-primary);

  // Transitions
  @include transition(border-color, border-width);

  &:focus {
    border: 2px solid var(--color-primary-base);
  }

  &::placeholder {
    color: transparent;
  }

  // Hide spinner buttons for number inputs
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  // Firefox
  &[type='number'] {
    -moz-appearance: textfield;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;

  .input {
    cursor: not-allowed;
  }
}
